import {BsFillPlayCircleFill} from "react-icons/bs";
import React from "react";
import {ImageModel} from "../../../models/domain/imageModel";
import {VideoModel} from "../../../models/domain/videoModel";
import {MediaType} from "../../../definitions/enums";

interface IProps {
    model: ImageModel | VideoModel;
    onClick: () => void;
    isActive: boolean;
}

export const Thumbnail = ({model, onClick, isActive}: IProps) => {
    const className = `${isActive ? 'active-thumbnail' : 'inactive-thumbnail'} position-relative text-center overlay-thumb-wrap mx-1 my-1`;

    const alt = (model.mediaType === MediaType.Image
            ? (model as ImageModel).alt
            : (model as VideoModel).filename)
        ?? 'Media Gallery Thumbnail';

    return (
        <div className={className} onClick={onClick} aria-hidden>
            <img
                src={model.thumbnailUrl}
                alt={alt}
                title={model.title}
                className="p-1"
                height={model.height ? model.height : 86}
                width={model.width ? model.width : 86}
                loading="lazy" decoding="async"
            />
            {model.mediaType == MediaType.Video && <PlayIcon/>}
        </div>
    );
};

const PlayIcon = () => (
    <div className="position-absolute top-50 start-50 translate-middle ">
        <div className="position-relative">
            <BsFillPlayCircleFill size={25}
                                  aria-hidden="true"
                                  style={{cursor: "pointer"}}
                                  className="text-primary"/>
            <div className="bg-white position-absolute top-50 start-50 translate-middle"
                 style={{height: "15px", width: "15px", zIndex: "-1"}}/>
        </div>
    </div>
);